module.exports = __webpack_public_path__ + "img/slika-6.29ec6ef7.png";